<template lang="html">
  <v-card style="width: 80vw;" class="mx-auto">
    <v-card-title>
      <h3 v-if="tipoTermo === 'termoUso'" class="headline mb-0">{{ `${$tc('label.termo_aceite', 1)} - ${$tc('label.portal_trade_termo_uso', 1)}` }}</h3>
      <h3 v-else class="headline mb-0">{{ $tc('label.termo_aceite', 1) }}</h3>
    </v-card-title>
    <v-card-text v-html="termo.conteudo">
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TermoAceiteUsuario',
  data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),
      termo: '',
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    idUsuario() {
      return this.usuarioLogado.id;
    },
    tipoTermo() {
      const { name } = this.$route;
      if (name === 'verAceiteTermoUso') {
        return 'termoUso';
      }
      return 'termoNomeacao';
    },
  },
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast(this.$t('message.acesso_negado'));
    },
    buscarTermo() {
      const { idAceite } = this.$route.params;
      const params = { idAceite, tipoTermo: this.tipoTermo };
      this.termoAceiteResources.obterAceite(params).then((response) => {
        this.termo = response.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
  },
  beforeMount() {
    this.buscarTermo();
  },
  mounted() {
  },
};
</script>
